import script from "./FooterDesignmuseumgent.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterDesignmuseumgent.vue?vue&type=script&setup=true&lang=js"

import "./FooterDesignmuseumgent.vue?vue&type=style&index=0&id=17c88a50&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c88a50"]])

export default __exports__